import React from "react";
import { Typography, Box, Button, Grid } from "@mui/material";
import { StepContainer } from "./StepContainer";
import { ExportSummary } from "../styled";
import { Step } from "../types";

interface ExportLogStepProps {
  onDownloadCsv?: () => Promise<void>;
  setCurrentStep: (step: Step) => void;
}

export const ExportLogStep: React.FC<ExportLogStepProps> = ({ onDownloadCsv, setCurrentStep }) => {
  const handleSelectNewMatchingRound = () => {
    setCurrentStep(Step.SELECT_MATCHING_ROUND);
  };

  const rightPanel = (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={3} mb={3} sx={{ width: '100%', margin: 0 }}>
        <Grid item xs={12} sm={4}>
          <ExportSummary>
            <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500, mb: 0.5 }}>
              23 successfully exported groups
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '12px', color: '#4CAF50', textTransform: 'uppercase', fontWeight: 500 }}>
              EXPORTED
            </Typography>
          </ExportSummary>
        </Grid>

        <Grid item xs={12} sm={4}>
          <ExportSummary>
            <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500, mb: 0.5 }}>
              11 unsuccessfully exported groups
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '12px', color: '#F44336', textTransform: 'uppercase', fontWeight: 500 }}>
              NOT EXPORTED
            </Typography>
          </ExportSummary>
        </Grid>

        <Grid item xs={12} sm={4}>
          <ExportSummary>
            <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 500, mb: 0.5 }}>
              6 unsuccessfully exported single residents
            </Typography>
            <Typography variant="body2" sx={{ fontSize: '12px', color: '#F44336', textTransform: 'uppercase', fontWeight: 500 }}>
              NOT EXPORTED
            </Typography>
          </ExportSummary>
        </Grid>
      </Grid>
      <Box display="flex" gap={2} mt={3} pl={2}>
        <Button
          variant="outlined"
          onClick={handleSelectNewMatchingRound}
          sx={{
            borderColor: '#1e3a5f',
            color: '#1e3a5f',
            '&:hover': {
              borderColor: '#1e3a5f',
              bgcolor: 'rgba(30, 58, 95, 0.04)'
            },
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '8px'
          }}
        >
          Select New Matching Round
        </Button>
        <Button
          variant="contained"
          onClick={onDownloadCsv}
          sx={{
            bgcolor: '#2167e2',
            '&:hover': { bgcolor: '#1a52b3' },
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            padding: '10px 24px',
            borderRadius: '8px',
            boxShadow: 'none'
          }}
        >
          View Export Log
        </Button>
      </Box>
    </Box>
  );

  return (
    <StepContainer rightPanel={rightPanel} />
  );
};
